import { useMutation } from '@tanstack/react-query';

import { TypeCodeState } from '../../types';
import { axiosInstance } from '~/services/fetchServiceV2';
import { type TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeCheckOutResponse = {
  code: string;
  message: string;
  data: {
    laborAccountId: number;
    checkInOutId: number;
    cluster: TypeCodeState;
    center: TypeCodeState;
    workPart: TypeCodeState;
    workProcessCode: string;
    workProcessDetailName: string;
    checkInTime: string;
    checkOutTime: string;
  };
};

/** @description 상용직 작업자가 직접 체크아웃 요청 시 사용되는 커스텀 훅 */
export const useCheckOut = () => {
  const { mutateAsync } = useMutation({
    mutationFn: () => {
      const endpoint = '/check-out';
      return axiosInstance.post<TypeCheckOutResponse>(endpoint);
    },
  });

  const requestCheckOut = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (res: TypeCheckOutResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(), onSuccess, onError);
  };

  return requestCheckOut;
};
